/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{padding-top:5px;padding-right:5px;position:relative;color:#fff}[_nghost-%COMP%]:hover{cursor:pointer}@media only screen and (min-width:768px){[_nghost-%COMP%]{margin-top:2px}}[_nghost-%COMP%]   span[_ngcontent-%COMP%]{position:absolute;border-radius:30%;padding:0 2px;background:#000;top:0;right:0;font-size:10px}"];
export { styles as styles };
